import { DeleteTag } from '../index'

export default function DeleteTagFunc(currDishId: string) {
  return DeleteTag(currDishId)
}
